import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'; // <-- Import hook
import { useOsDetection } from '../hooks/useOsDetection';
import './DesktopDownloadPrompt.css'; // We will create this
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faTimes } from '@fortawesome/free-solid-svg-icons';

// IMPORTANT: Update these with your exact installer file names
const DOWNLOAD_LINKS = {
    Windows: '/downloads/Zakiya-Chat-Setup-1.0.0.exe',
    // macOS: '/downloads/Zakiya-Chat-1.0.0.dmg',
};

const DesktopDownloadPrompt = () => {
    const { t } = useTranslation(); // <-- Use hook
    const os = useOsDetection();
    const [isVisible, setIsVisible] = useState(true);

    const downloadLink = DOWNLOAD_LINKS[os];

    // If the OS is unknown or there's no link for it, don't show the prompt
    if (!downloadLink || !isVisible) {
        return null;
    }

    return (
        <div className="desktop-download-prompt">
            <div className="download-prompt-content">
                <FontAwesomeIcon icon={faDesktop} className="desktop-icon" />
                <p>{t('desktop_prompt_text')}</p>
                <a href={downloadLink} download className="download-button">
                    {t('desktop_download_button', { os: os })}
                </a>
            </div>
            <button className="dismiss-button" onClick={() => setIsVisible(false)}>
                <FontAwesomeIcon icon={faTimes} />
            </button>
        </div>
    );
};

export default DesktopDownloadPrompt;